export default {
  metrics: {
    nrr: {
      title: 'NRR % (neljännesvuosittain)',
      description:
        '(Tilausliikevaihto {{currentMonth}} (Q{{currentQuarter}}) + palvelumaksutuotot {{currentMonth}} (Q{{currentQuarter}})) / (Tilausliikevaihto {{prevMonth}} (Q{{prevQuarter}} lopussa) + palvelumaksutuotot {{prevMonth}} (Q{{prevQuarter}} lopussa)) * 100',
    },
    upgrades: 'Tilin päivitykset',
    downgrades: 'Tilin alennukset',
    gte_c_tier: 'Tilit ≥ C-taso',
    churn: 'Poistuma (keskeytetty)',
    offers_turned_on: 'Tarjoukset käytössä',
    flyers_sent: 'Lähetetyt mainokset',
    on_google_ads_trial: 'Google Ads -kokeilussa',
    converted_google_ads: 'Onnistuneesti muunnettu Google Ads',
    first_time_500_monthly_sales: 'Ensimmäinen 500 €:n kuukausi',
    '14_days_no_sales': '14 päivää live, ei liikevaihtoa',
  },
  details: {
    address: 'Osoite',
    subscriptions: 'Nykyiset tilaukset',
    best_sales: 'Paras kuukausi ikinä',
    sales: '{{month}} myynti',
    tier: '{{month}} taso',
    live_from: 'Julkaisupäivä',
    owner_phone: 'Omistajan puhelin',
    owner_email: 'Omistajan sähköposti',
    owner: 'Omistajan nimi',
    name: 'Ravintola',
    export_csv: 'Vie CSV',
  },
  publish: 'Julkaise',
  unpublish: 'Poista julkaisusta',
};
